/**
 * 枚举
 */

// 用户付费状态
export const EUserMeberStatus = {
  Normal: 0, // 正常使用
  Holding: 1, // 保留期
  Expired: 2, // 过期
}

// var EUserMeberStatus;
// (function (v) {
//     v[v["Normal"] = 0] = "Normal";
//     v[v["Holding"] = 0] = "Holding";
//     v[v["Expired"] = 0] = "Expired";
// })(EUserMeberStatus || (EUserMeberStatus = {}));

// fax 质量
export const EFaxQuality = {
  // STANDARD("standard"),
  // FINE("fine"),
  // SUPERFINE("superfine");

  // STANDARD: "standard",
  // FINE: "fine",
  // SUPERFINE: "superfine",

  Smooth: 'standard',
  Standard: 'fine',
  Excellent: 'superfine',
}
